import { type FC } from 'react'

export const StoryblokCategoryHeader: FC<{ title: string | undefined }> = ({
  title,
}) => {
  return (
    <section className="container flex items-center">
      {title ? <h1 className="text-4xl">{title}</h1> : null}
    </section>
  )
}
